import { Atom } from "effect/unstable/reactivity";
import { applyShellStreamEvent } from "./shellSnapshotReducer.js";
export const EMPTY_SHELL_SNAPSHOT_STATE = Object.freeze({
    data: null,
    error: null,
    isPending: false,
});
const INITIAL_SHELL_SNAPSHOT_STATE = Object.freeze({
    data: null,
    error: null,
    isPending: true,
});
const knownShellSnapshotKeys = new Set();
export const shellSnapshotStateAtom = Atom.family((key) => {
    knownShellSnapshotKeys.add(key);
    return Atom.make(INITIAL_SHELL_SNAPSHOT_STATE).pipe(Atom.keepAlive, Atom.withLabel(`shell-snapshot:${key}`));
});
export const EMPTY_SHELL_SNAPSHOT_ATOM = Atom.make(EMPTY_SHELL_SNAPSHOT_STATE).pipe(Atom.keepAlive, Atom.withLabel("shell-snapshot:null"));
export function getShellSnapshotTargetKey(target) {
    return target.environmentId;
}
export function createShellSnapshotManager(config) {
    function getSnapshot(target) {
        const targetKey = getShellSnapshotTargetKey(target);
        if (targetKey === null) {
            return EMPTY_SHELL_SNAPSHOT_STATE;
        }
        return config.getRegistry().get(shellSnapshotStateAtom(targetKey));
    }
    function setState(targetKey, nextState) {
        config.getRegistry().set(shellSnapshotStateAtom(targetKey), nextState);
    }
    function markPending(target) {
        const targetKey = getShellSnapshotTargetKey(target);
        if (targetKey === null) {
            return;
        }
        const current = config.getRegistry().get(shellSnapshotStateAtom(targetKey));
        setState(targetKey, {
            data: current.data,
            error: null,
            isPending: true,
        });
    }
    function syncSnapshot(target, snapshot) {
        const targetKey = getShellSnapshotTargetKey(target);
        if (targetKey === null) {
            return;
        }
        setState(targetKey, {
            data: snapshot,
            error: null,
            isPending: false,
        });
    }
    function applyEvent(target, event) {
        const targetKey = getShellSnapshotTargetKey(target);
        if (targetKey === null) {
            return;
        }
        const current = config.getRegistry().get(shellSnapshotStateAtom(targetKey));
        if (current.data === null) {
            return;
        }
        setState(targetKey, {
            data: applyShellStreamEvent(current.data, event),
            error: null,
            isPending: false,
        });
    }
    function invalidate(target) {
        if (target) {
            const targetKey = getShellSnapshotTargetKey(target);
            if (targetKey !== null) {
                setState(targetKey, EMPTY_SHELL_SNAPSHOT_STATE);
            }
            return;
        }
        for (const key of knownShellSnapshotKeys) {
            setState(key, EMPTY_SHELL_SNAPSHOT_STATE);
        }
    }
    function reset() {
        invalidate();
    }
    return {
        markPending,
        syncSnapshot,
        applyEvent,
        getSnapshot,
        invalidate,
        reset,
    };
}
